module.exports = __webpack_public_path__ + "static/satisfaction-dda481dd6e0dd7a883f114714d385c79.svg";